// 학습 문서 iframe 속성. 외부 콘텐츠 서버(cont1/cdn)의 이미 제작된 HTML 차시는 스크립트·자체 플레이어가 돌아야 하므로
// sandbox 에 스크립트·같은 출처·양식·팝업만 허용하고 상위 창 이동(allow-top-navigation)은 막는다.
// 다른 출처 문서라 allow-same-origin 이 있어도 우리 화면의 저장소·토큰에는 접근할 수 없다.
// 우리 출처에서 내려주는 파일(PDF)은 서버 CSP가 따로 막고, sandbox 를 걸면 브라우저 PDF 보기가 차단되므로 그대로 둔다.
export const EXTERNAL_DOCUMENT_SANDBOX = 'allow-scripts allow-same-origin allow-forms allow-popups'

export function documentFrame(source, origin) {
  let url
  try { url = new URL(source, origin) } catch { return { sandbox: '' } }
  if (url.origin === origin) return {}
  return { sandbox: EXTERNAL_DOCUMENT_SANDBOX, allow: 'fullscreen', allowfullscreen: true }
}
